<template>
    <VeeField name="telephone" v-model="useCartOverview().value.telephone" v-slot="{field, meta, errors}" :rules="(function(){
            let required = false
            bins?.forEach(bin => {
                if(bin.phoneRequired) required = true
            })
            return (required && !optional ? 'required|phone':'phone')
        })()">
        <div :class="meta.touched ? (meta.valid) ? 'valid' : 'invalid' : ''" >
            <input v-bind="field" class="inp sm" type="text" :placeholder="(function(){
            let required = false
            bins?.forEach(bin => {
                if(bin.phoneRequired) required = true
            })
            return 'Telefonnummer' + (required && !optional ? '*':'')
        })()" />
        </div>
        <span>{{ errors[0] }}</span>
        <div v-if="!isReservation && !optional && (function(){
            let required = false
            bins?.forEach(bin => {
                if(bin.phoneRequired) required = true
            })
            return required
        })()" class="py-4 text-xs text-paragraph-light">
            Bitte geben Sie Ihre Telefonnummer an, damit das Speditionsunternehmen mit
            Ihnen einen Liefertermin vereinbaren kann.
        </div>
    </VeeField>
</template>
<script setup lang="ts">
    const props = defineProps({
        isReservation: {
            type: Boolean,
            default: () => {
                return inject("isReservation");
            },
        },
        bins: {
            type: Object
        },
        optional: {
            type: Boolean,
            default: false
        }
    })
    useLibPhoneValidation();
</script>